import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = "public/assets/images/Hub_LogoHI-1762941543093.png"
      }}
      {...props}
    />
  );
}

export default Image;
